import React from 'react';
import { IMonitoringToolkit } from '@components-clean/core/monitoring-toolkit/interface';
import MonitoringToolkitWrapper, {
    MonitoringToolkitWrapperProps,
} from '@pages-clean/central-monitoring/monitoring-toolkit/wrapper';

export const baseMonitoringToolkitHelper: IMonitoringToolkit = {
    TOOLKIT_STATE_KEY: 'CentralMonitoringToolkit.OpenState',
    BOTTOM_PANEL_MIN_SIZE: 0,
    COLLAPSED_SIZE: '',
    AUTO_SIZE: '',
    translationKey: '',

    canUserViewToolkit() {
        return false;
    },

    canEditToolkit() {
        return false;
    },

    tabsContent() {
        return [];
    },

    clearMonitoringToolKitOpenState() {},

    hasUnsavedChanges() {
        return false;
    },

    clearUnsavedChanges() {},
};

type Props = Omit<MonitoringToolkitWrapperProps, 'toolkitHelper'>;

export const BaseMonitoringToolkit = (props: Props) => {
    return <MonitoringToolkitWrapper {...props} toolkitHelper={baseMonitoringToolkitHelper} />;
};
